import { render, staticRenderFns } from "./Practitioner.vue?vue&type=template&id=54fd4c4c"
import script from "./Practitioner.vue?vue&type=script&lang=js"
export * from "./Practitioner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports